import React from 'react'
import styled from 'styled-components'
import CheckBoxGroup from '@pc/components/Works/Panel/shared/checkbox/CheckBoxGroup'
import CheckBoxInputSet from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInputSet'
import CheckBoxInput from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/checkbox/CheckBoxLabel'
import type { Prefecture } from '@pc/components/Works/Panel/type'

interface PropsType {
  prefecture: Prefecture
  cities: Prefecture[]
  selectedCityIds: string[]
  changeCityIds: (arg: string[]) => void
}

const CheckBoxAreaInputSet = styled(CheckBoxInputSet)`
  width: 25%;
`

const AreaBoxWrapper = styled.div`
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  bottom: 85px;
  left: 0;
  overflow-y: hidden;
  padding: 15px 20px;
  position: absolute;
  top: 68px;
  width: 100%;
`

const AreaBoxContent = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
`

const renderCityCheckboxes = (cities: Prefecture[], selectedCityIds: string[], toggleCheckbox: React.ChangeEventHandler) => {
  return cities.map((city) => {
    const CityId = `city-${city.id}`
    return (
      <CheckBoxAreaInputSet key={CityId}>
        <CheckBoxInput
          type="checkbox"
          id={CityId}
          value={city.attributes.compat_id}
          onChange={toggleCheckbox}
          checked={selectedCityIds.includes(String(city.attributes.compat_id))}
        />
        <CheckBoxLabel htmlFor={CityId}>{city.attributes.name}</CheckBoxLabel>
      </CheckBoxAreaInputSet>
    )
  })
}

const AreaBox = (props: PropsType) => {
  const { prefecture, cities, selectedCityIds, changeCityIds } = props

  const toggleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cityId = e.target.value

    if (e.target.checked) {
      const concatedCityIds = selectedCityIds.concat(cityId)
      changeCityIds(concatedCityIds)
    } else {
      const filteredCityIds = selectedCityIds.filter((selectedCityId) => selectedCityId !== cityId)
      changeCityIds(filteredCityIds)
    }
  }

  const toggleAllCheckbox = () => {
    if (isAllSelected()) {
      changeCityIds([])
    } else {
      const cityCompatIds = cities.map((city) => city.attributes.compat_id.toString())
      changeCityIds([...new Set([...selectedCityIds.concat(cityCompatIds)])])
    }
  }

  const isAllSelected = () => {
    return selectedCityIds.length === cities.length
  }

  return (
    <AreaBoxWrapper>
      <AreaBoxContent>
        <CheckBoxGroup>
          <CheckBoxInputSet>
            <CheckBoxInput type="checkbox" id="rootCity" onChange={toggleAllCheckbox} checked={isAllSelected()} />
            <CheckBoxLabel htmlFor="rootCity">{prefecture.attributes.name}内のエリア全て</CheckBoxLabel>
          </CheckBoxInputSet>
        </CheckBoxGroup>
        <CheckBoxGroup>{renderCityCheckboxes(cities, selectedCityIds, toggleCheckbox)}</CheckBoxGroup>
      </AreaBoxContent>
    </AreaBoxWrapper>
  )
}

export default AreaBox
